import { Variants } from 'framer-motion';

export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.4,
      delay: 0.2
    }
  }
};

export const children = {
  hidden: { opacity: 0 },
  show: { opacity: 1 }
};

export const ErrorVariants = {
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3
    }
  },
  hide: {
    opacity: 0,
    y: '-100%',
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    y: '-100%',
    transition: {
      duration: 0.3
    }
  }
};

export const listVariants: Variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.3 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

export const listItemVariants: Variants = {
  visible: (i) => ({
    opacity: 1,
    transition: {
      delay: i * 0.3
    }
  }),
  hidden: { opacity: 0 }
};
